<div class="validations-list">
  <label *ngFor="let validations of _validations" [for]="validations.id" [title]="validations.description"
    [ngClass]="{ active: validations.checked }">
    <input type="checkbox" [(ngModel)]="validations.checked" [name]="validations.description" [id]="validations.id"
      [checked]="validations.checked" (change)="onChangeValidations($event)" />
    {{ validations.id }}
  </label>
</div>